export type ModelDetailVersionsFilter =
  | "all"
  | "draft"
  | "in_review"
  | "active"
  | "superseded";

export const MODEL_DETAIL_VERSION_FILTER_ITEMS: Array<{
  value: ModelDetailVersionsFilter;
  label: string;
}> = [
  { value: "all", label: "All" },
  { value: "draft", label: "Draft" },
  { value: "in_review", label: "In review" },
  { value: "active", label: "Active" },
  { value: "superseded", label: "Superseded" },
];

export function modelDetailVersionMatchesFilter(
  status: string,
  filter: ModelDetailVersionsFilter
): boolean {
  if (filter === "all") return true;
  if (filter === "draft") {
    return status === "draft" || status === "processing";
  }
  return status === filter;
}
